import { Routes } from '@angular/router';
import { AccountConfirmPage } from './Account/Confirm/AccountConfirmPage';
import { AccountRegisterPage } from './Account/Register/Pages/AccountRegisterPage';
import { BuilderPage } from './Builder/Pages/BuilderPage';
import { BuilderRegisterPage } from './Builder/Register/Pages/BuilderRegisterPage';
import { HomePage } from './Home/Pages/HomePage';
import { PricingPage } from './Pricing/Pages/PricingPage';
import { TermsPage } from './Terms/Pages/TermsPage';
import { SubscribePage } from './Subscribe/Pages/SubscribePage';
import { AuthenticationGuard } from '../shared/guards/authentication.guard';
import { SubscribeReturnPage } from './Subscribe/Return/Pages/SubscribeReturnPage';

export const routes: Routes = [
    { path: '', component: HomePage },
    { path: 'pricing', component: PricingPage },
    { path: 'terms', component: TermsPage },
    { path: 'builder', component: BuilderPage },
    { path: 'builder/register', component: BuilderRegisterPage },
    { path: 'account/confirm', component: AccountConfirmPage },
    { path: 'account/register/:plan', component: AccountRegisterPage },
    { path: 'subscribe/return/:id', component: SubscribeReturnPage, canActivate: [AuthenticationGuard] },
    { path: 'subscribe/:plan', component: SubscribePage, canActivate: [AuthenticationGuard] }
];
